<eb-form
  #formComponent
  *ngIf="formConfig$ | async as formConfig"
  [formConfig]="formConfig"
  context="contact"
  (formSubmit)="onSubmit($event)"
  [submitting]="sending$ | async"
></eb-form>
